<template>
  <div class="container" contextual-search-enable="false">
    <div class="aside-gap" />
    <div id="cpc-comment-box" :class="commentBoxClass" class="main-content">
      <component :is="currentPage" />
    </div>
    <div class="aside-gap" />
  </div>
</template>

<script lang="ts">
import { computed, ref, watch, defineComponent, onMounted } from 'vue';
import { constant } from '@cpc/comment-sdk-common';
import {
  useProvider,
  useAdSlot,
  useGlobalState,
  useDisableSelected,
} from '@cpc/comment-sdk-core-comment';

import CommentList from '../src/components/CommentList.vue';
import CommentSecondDetail from '../src/components/CommentSecondDetail.vue';

import { useNightMode } from './core/useNightMode/index';
import { useOnCommentClickProvide } from './core/useOnCommentClickProvide/index';
import { useBrowserVersion } from './core/useBrowserVersion';
import { useCommentScene } from './core/useCommentScene';

export default defineComponent({
  components: {
    CommentList,
    CommentSecondDetail,
  },

  setup(props, { emit }) {
    useProvider();
    useOnCommentClickProvide();

    const { isNightMode } = useNightMode();

    const { getColorOsVersion } = useBrowserVersion();

    const { infinityCommentScene, microCommentScene } = useCommentScene();

    const globalState = useGlobalState();

    const currentPage = ref('CommentList');
    // const pages = ['CommentList', 'CommentSecondDetail'];
    const isSecondCommentDetail = globalState.pageType === constant.PageType.SECOND_COMMENT_DETAIL;

    if (isSecondCommentDetail) {
      currentPage.value = 'CommentSecondDetail';
    }

    if (globalState.feature.enableSdkInjectAd) {
      const { slotCallback } = useAdSlot();

      globalState.slotCallback = slotCallback;
    }

    const isVideoType = computed(() => {
      return (
        parseInt(String(globalState.documentMeta.styleType)) === 4
        || infinityCommentScene()
        || microCommentScene()
      );
    });

    // 添加角标
    const commentBoxClass = computed(() => {
      return {
        'debug-corner':
          location.hostname === '127.0.0.1'
          || location.hostname === 'doris-test.yidianzixun.com'
          || location.hostname.indexOf('wanyol.com') > -1
          || false,
        'video-dark': isVideoType.value,
        'comment-detail-spacing':
          (globalState.pageType === constant.PageType.COMMENT_DETAIL
            || globalState.pageType === constant.PageType.SECOND_COMMENT_DETAIL)
          && globalState.documentMeta.styleType === 1
          && getColorOsVersion() === '13',
        'second-comment-detail': isSecondCommentDetail,
      };
    });

    globalState.isNightMode = isNightMode.value;

    watch(isNightMode, (value) => {
      globalState.isNightMode = value;
    });

    onMounted(() => {
      if (
        globalState.pageType === constant.PageType.COMMENT_DETAIL
        || globalState.pageType === constant.PageType.SECOND_COMMENT_DETAIL
      ) {
        const el = document.getElementById('cpc-comment-box');

        useDisableSelected(el);
      }
    });

    return { currentPage, commentBoxClass };
  },
});
</script>

<style lang="scss" scoped>
@import './assets/css/styling-mixin.scss';

#cpc-comment-box {
  overflow: auto;
  color: #000;
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  user-select: none;
  -webkit-user-select: none;
}

.debug-corner {
  background-size: 90px 90px;
  background-image: url('./assets/img/corner-new.png');
  background-position: 0 0;
  background-repeat: no-repeat;
}

.comment-detail-spacing {
  padding-top: 30px;
  margin-top: 18px;
}

#cpc-comment-box {
  &.video-dark {
    height: 100vh;
  }

  &.second-comment-detail {
    @include os-browser-styling('', '', false, false, true) {
      background-color: unset;
    }
  }
  @include os-browser-styling('', '', false, false, true) {
    background-color: #1e1e1e;
  }
  // 禁用内核反色
  @include os-browser-styling((13), 'not-video', false, false, true, true) {
    background-color: #0c0c0c;
  }
}
</style>

<style lang="scss">
@import './assets/css/styling-mixin.scss';

// 一点页面设置所有元素为border-box，故对此覆盖
#comments-container .container * {
  box-sizing: content-box;
}

// 全局按压反馈色值、广告按压色值
.touch-feed-back,
.heytapad-press-background {
  background-color: rgba(0, 0, 0, 0.1);
  @include os-browser-styling('', '', false, false, true) {
    background-color: rgba(240, 240, 240, 1);
  }
  @include os-browser-styling('', '', false, false, true, true) {
    background-color: rgba($color: #fff, $alpha: 0.1);
  }
}

// 强制覆盖一点源小视频，短视频评论页样式
.appid-oppo #main {
  padding-top: 0;
}

.appid-oppo #main > * {
  padding-left: 0;
}
</style>
